import Skeleton from '@carvana/ds-skeleton';

export default function SectionSkeleton() {
  return (
    <div className="flex w-full flex-col gap-4xl">
      {/* Top content skeleton */}
      <div className="h-[560px] w-full md:h-[368px] ">
        <Skeleton height="100%" width="100%" />
      </div>

      <div className="flex flex-col gap-2xl">
        {/* Carousel title skeleton */}
        <Skeleton className="rounded-md" height="28px" width="100%" />

        {/* Slide skeleton */}
        <Skeleton className="rounded-md" height="60px" width="100%" />
      </div>

      {/* SebastianQuestions skeleton */}
      <div className="flex flex-col gap-2xl rounded-md bg-white px-2xl sm:px-0">
        {/* Header row with icon and title */}
        <div className="flex flex-row items-center gap-md">
          <Skeleton className="rounded-sm" height="24px" width="24px" />
          <Skeleton className="rounded-md" height="28px" width="280px" />
        </div>

        {/* Questions skeleton */}
        <div className="flex flex-wrap gap-lg">
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={index}
              className="rounded-md"
              height="36px"
              width="200px"
            />
          ))}
        </div>

        {/* Ask something else button skeleton */}
        <Skeleton className="rounded-md" height="36px" width="147px" />
      </div>
    </div>
  );
}
